<template>
 <div class="reserve">
  <div class="reserve-title">秒杀设置</div>
  <div class="com-content"  v-for="(item,index) in form.spikeSections" :key="index">
    <div >
      <div class="number">
        <span>场次{{index+1}}</span>
        <span class="replace" v-if="form.spikeSections.length > 1" @click="deleteSessions(index)">
          删除
        </span>
      </div>
      <van-field
        required
        v-model="item.startTime"
        label="开始时间" 
        label-align="left" 
        input-align="right" 
        readonly 
        right-icon="arrow" 
        class="signup-type top" 
        placeholder="请选择开始时间" 
        @click="timeChange(1,item)"
      />
      <van-field
        required
        v-model="item.endTime"
        :disabled="!item.startTime"
        label="结束时间" 
        label-align="left" 
        input-align="right" 
        readonly 
        right-icon="arrow" 
        class="signup-type top" 
        placeholder="请选择结束时间"
        @click="timeChange(2,item)"
      />
      <van-field
        required
        v-model="item.boolPrePayName"
        label="本次使用秒杀定金" 
        label-align="left" 
        input-align="right" 
        readonly 
        right-icon="arrow" 
        label-width="10em"
        class="signup-type top" 
        placeholder="请选择"
        @click="changeWriteOff(item,'prePay')"
      />
     
      <!-- <van-field
        required
        v-model="item.writeOff"
        label="本场是否自动核销" 
        label-align="left" 
        input-align="right" 
        readonly 
        right-icon="arrow" 
        label-width="10em"
        class="signup-type top" 
        placeholder="请选择"
        @click="changeWriteOff(item,'writeOff')"
      /> -->
      <van-field 
        name="radio" 
        label="本场是否自动核销"  
        label-align="left" 
        input-align="right"
        label-width="10em"
      >
        <template #input>
          <van-radio-group  v-model="item.boolVerification" direction="horizontal" icon-size="16px" checked-color="#FF6B31" >
            <van-radio name="true">是</van-radio>
            <van-radio name="false">否</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field
        v-model="item.sectionLimit"
        type="digit"
        label="本场活动限购" 
        label-align="left" 
        input-align="right" 
        class="signup-type top" 
        placeholder="请输入"
        @blur="checkFeeValid(index,'sectionLimit')"
      >
        <span slot="right-icon">次</span>
      </van-field>
      <van-field
        v-model="item.goodsLimit"
        type="digit"
        label="每件商品限购" 
        label-align="left" 
        input-align="right" 
        class="signup-type top" 
        placeholder="请输入"
        @blur="checkFeeValid(index,'goodsLimit')"
      >
        <span slot="right-icon">次</span>
      </van-field>
      <template v-if="item.spikeGoods.length">
        <div class="commodity-box" v-for="(spikeGoods, index1) in item.spikeGoods" :key="index1">
          <template v-if="spikeGoods.goodName">
            <div class="name">
              <span class="name-state" v-if="from == 'manager' && spikeGoods.goodName && !item.isNewAdd">
                {{spikeGoods.status == 0 ? '使用中' : '已下架'}}{{item.isNewAdd}}
              </span>
              <span class="title">{{spikeGoods.goodName}}</span>
            </div>
            <div class="icon-box">
              <div class="del" @click="deletGoods(item.spikeGoods,index1)">删除</div>
              <span v-if="from != 'manager'" @click="editGoods(spikeGoods,index,index1)">编辑</span>
              <span v-else @click="editGoods(spikeGoods,index,index1)" >
                {{spikeGoods.status == 0 && !item.isNewAdd ? '编辑并下架' : '编辑'}}
              </span>
            </div>
          </template>
        </div>
      </template>
      <div class="add-goods-btn" @click="addGoods(item,index)">新增商品</div>
    </div>
  </div>
  <div class="add-range-btn" @click="addSessions">新增场次</div>
  <add-goods-pop
    :defaultPhoneHeight="defaultPhoneHeight"
    :isAddGoods.sync="isAddGoods" 
    :spikeGoodsItem="spikeGoodsItem" 
    v-if="isAddGoods"
    @addGoodsSuccess="addGoodsSuccess"
  />
  <van-popup position="bottom" v-model="isTimeShow" get-container="body">
    <van-datetime-picker
      v-model="currentDate"
      type="datetime"
      title="选择完整时间"
      :min-date="minDate"
      :max-date="maxDate"
      @confirm="timeConfirm"
      @cancel="timeCancel"
    />
  </van-popup>
  <van-action-sheet
    get-container="body"
    v-model="isWriteOff"
    :actions="actions"
    cancel-text="取消"
    close-on-click-action
    @cancel="isWriteOff = false"
    @select="selectWriteOff"
  />
 </div>
</template>

<script>
import loadingMixin from '@/mixins/loading-mixin'
import { round2Places } from "@/utils/utils";
import dayjs from "@/utils/dayjs";
import addGoodsPop from './add-goods-pop'
export default {
  mixins: [loadingMixin],
  components: {
    addGoodsPop
  },
  props: {
    value:  {
      type: Object,
      default() {
        return {}
      }
    },
    basicInfoForm: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  computed: {
    form: {
      get() {
        return this.value
      },
      set(newVal) {
        this.$emit('change', newVal)
      }
    },
    from() {
      return this.$route.query.from
    },
    activityId() {
      return  this.$route.query.activityId || ''
    },
    isClone() {
      return this.$route.query.from == 'clone';
    },
    isActiveStart() {
      if (this.from == 'manager') {
        const {startTime,endTime } = this.basicInfoForm
        let activeStartTime = startTime.split(" ").length > 1 ? startTime : startTime + " 00:00:00";
        let activeEndTime = endTime.split(" ").length > 1 ? endTime : endTime + " 23:59:59";
        return new Date().getTime() > new Date(activeStartTime).getTime()
      }
      return false
    }
  },
  data() {
    return {
      defaultPhoneHeight: 0,
      spikeSectionsIndex: 0,
      spikeGoodsIndex: 0,
      spikeSectionsItem: {},
      spikeGoodsItem: {},
      changeType: 0,
      isTimeShow: false,
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2025, 10, 1),
      currentDate: new Date(),
      isWriteOff: false, // 是否核销弹窗
      actions: [{name: '是',type: 'true'},{name: '否', type: 'false'}],
      isAddGoods: false, // 添加商品弹窗
      sheetChangeType: ''
    }
  },
  methods: {
    timeChange(type,item) {
      // 编辑 并且不是新增的场次
      if (this.from == 'manager' && !item.isNewAdd) {
        const {startTime,endTime } = item
        // 秒杀场次进行中 只能修改结束时间
        let formatStartTime = startTime.replace(/-/g, "/");
        let formatEndTime = endTime.replace(/-/g, "/");
        if (new Date(formatStartTime).getTime() < new Date().getTime() && type == 1) {
          return
        }else if (new Date(formatEndTime).getTime() < new Date().getTime() && type == 2) {
          return
        }
      }
      this.changeType = type
      this.spikeSectionsItem = item
      if (!this.spikeSectionsItem.startTime && type == 2) return
      this.isTimeShow = true
    },
    timeConfirm(e) {
      this.isTimeShow = false
      // 开始时间
      if (this.changeType == 1) {
        this.spikeSectionsItem.startTime = dayjs(e).format("YYYY-MM-DD HH:mm:ss")
        this.spikeSectionsItem.endTime = ''
      }else if (this.changeType == 2) {
        if (new Date(e).getTime() <= new Date(this.spikeSectionsItem.startTime).getTime()) {
          this.$toast('结束时间不能小于等于开始时间')
          return
        }
        this.spikeSectionsItem.endTime = dayjs(e).format("YYYY-MM-DD HH:mm:ss")
      }
    },
    timeCancel() {
      this.isTimeShow = false
    },
    // 核销选择
    changeWriteOff(item,type) {
      if (type == 'prePay' && item.spikeGoods.length) {
         this.$toast('请清空本场商品后，再来调整当前参数')
        return 
      }
      this.spikeSectionsItem  = item
      this.sheetChangeType = type
      this.isWriteOff = true
    },
    selectWriteOff(e) {
      if (this.sheetChangeType == 'prePay') {
        this.spikeSectionsItem.boolPrePayName = e.name
        this.spikeSectionsItem.boolPrePay = e.type
      } else if (this.sheetChangeType == 'writeOff') {
        this.spikeSectionsItem.boolVerification = e.type
        this.spikeSectionsItem.writeOff = e.name
      }
      
    },
    addGoods(item,index) {
      if (!item.boolPrePay) {
        this.$toast('请先选择本场是否使用定金')
        return
      }
      this.spikeGoodsItem = {
        isNewAddSections: this.form.spikeSections[index].isNewAdd || false,
        activityId: this.isClone ? '' : this.activityId,
        sectionId: this.isClone ? '' : item.sectionId || '',
        boolPrePay: JSON.parse(item.boolPrePay),
        goodName: '',
        oldPrice: '',
        spikePrice: '',
        goodsTag: '',
        goodsNumber: '',
        virtualNumber: '',
        headImgList:[],
        detailsImg:[],
        preSpikePrice: '',
      }
      this.spikeSectionsIndex = index,
      this.spikeGoodsIndex = this.form.spikeSections[index].spikeGoods.length
      this.isAddGoods = true
    
    },
    deletGoods(spikeGoods,index) {
      this.$dialog.confirm({
        title: '删除确定',
        message:`商品删除后将无法恢复！<br/>请问是否删除商品？`,
      })
        .then(() => {
          if (this.from == 'manager' && spikeGoods[index].goodName) {
            let parames = {
              goodsId: this.isClone ? '' : spikeGoods[index].goodsId,
              activityId: this.isClone ? '' : this.activityId
            }
            this.$api.spike.deleteGoods(parames).then(res => {
              if (res.success) {
                this.$toast('删除成功')
                spikeGoods.splice(index,1)
              }
            })
          }else {
            spikeGoods.splice(index,1)
          }
        })
        .catch(() => {
          // on cancel
        });
    },
    // 编辑商品
    editGoods(item,index,index1) {
      this.spikeGoodsItem = {...item,headImgList:[...item.headImgList],detailsImg:[...item.detailsImg]}
      this.spikeGoodsItem.boolPrePay = JSON.parse(this.form.spikeSections[index].boolPrePay),
      this.spikeGoodsItem.isNewAddSections = this.form.spikeSections[index].isNewAdd || false,
      this.spikeSectionsIndex = index,
      this.spikeGoodsIndex = index1
      // 编辑
      if (this.spikeGoodsItem.goodName && this.from == 'manager' && !this.spikeGoodsItem.isNewAddSections) {
        const {startTime} = this.form.spikeSections[index]
        // 秒杀活动是否开始
        let isActiveStart = new Date(startTime).getTime() < new Date().getTime()
        this.spikeGoodsItem.isActiveStart = isActiveStart
        // 使用中
        if (item.status == 0) {
          this.$dialog.confirm({
            title: '确认提示',
            message:`下架后将无法选购本商品,待上架后才恢复,<br/>请问是否下架并编辑本商品？`,
          })
            .then(() => {
              this.editLower(item)
            }).catch(()=>{})
        }else {
          this.isAddGoods = true
        }
        return
      }
      this.isAddGoods = true
     
    },
    editLower(item) {
      let parames = {
        activityId: this.activityId,
        goodsId: item.goodsId,
        sectionId: item.sectionId
      }
      this.showLoading();
      this.$api.spike.edit(parames).then(res => {
        item.status = 1
        // 销售量
        // this.spikeGoodsItem.volume = res.data
        this.isAddGoods = true 
      }).finally(_=> {
        this.hideLoading();
      })
    },
    addGoodsSuccess(item) {
      this.form.spikeSections[this.spikeSectionsIndex].spikeGoods[this.spikeGoodsIndex] = item
      this.$emit('change', this.form)
    },
   // 添加场次
   async addSessions() {
      let data = {}
      if (this.from == 'manager') {
       data = await this.$api.spike.getNextSectionId()
      }
      this.form.spikeSections.push({
        isPreserve: true,
        activityId: this.isClone ? '' : this.activityId,
        startTime: '',
        endTime: '',
        boolPrePay: '',
        boolPrePayName: '',
        boolVerification: 'true',
        sectionLimit: '',
        goodsLimit: '',
        sectionId: data.data || '',
        writeOff: '',
        isNewAdd: true,
        spikeGoods: []
      })
    },
    // 删除场次
    deleteSessions(index) {
        this.$dialog.confirm({
          title: '删除确定',
          message:`场次删除后，所有数据无法恢复<br/>请问是否要删除场次？`,
        })
          .then(() => {
            if (this.from == 'manager' && !this.form.spikeSections[index].isPreserve) {
              let parames = {
                sectionId: this.isClone ? '' : this.form.spikeSections[index].sectionId,
                activityId: this.isClone ? '' : this.activityId
              }
              this.$api.spike.deleteSection(parames).then(res => {
                if (res.success) {
                  this.$toast('删除成功')
                  this.form.spikeSections.splice(index, 1)
                }
              })
            }else {
              this.form.spikeSections.splice(index, 1)
            }
          })
          .catch(() => {
            // on cancel
          });
    }, 
    checkFeeValid(index,fieldName) {
      const model = this.form.spikeSections;
      const fieldValue = model[index][fieldName];
      model[index][fieldName] = round2Places(fieldValue)
    },
    cloneData() {
      function recursion(arr) {
        arr.forEach(item => {
          for(let [key,value] of Object.entries(item)) {
            if (!Array.isArray(value)) {
              if (item.sectionId) delete item.sectionId
              if (item.goodsId) delete item.goodsId
              if (item.goodsId) delete item.goodsId
              if (item.activityId) delete item.activityId
            }else {
              recursion(value)
            }
          }
        })
      }
      recursion(this.form.spikeSections)
    }  
  },
  created() {
    this.defaultPhoneHeight = window.innerHeight
    if (this.isClone) {
      this.cloneData()
    }
  }
}
</script>

<style lang="stylus" scoped>
.reserve {
  margin: 15px 0;
  .reserve-title {
    padding: 15px 0 0 15px;
    font-size: 14px;
    font-weight: bold;
    color: #303133;
  }
  .com-content {
    margin 10px 15px
    padding 4px
    background-color: #fff
    border-radius: 8px;
    .number {
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #606266;
      font-weight: 600;
      height: 30px;
      margin: 0 15px;
      .replace {
        color: #ff6b31;
      }
    }
    .signup-type {
      span {
        margin-left: 10px;
      }
    }
    .commodity-box {
      display: flex;
      justify-content: space-between;
      margin: 15px;
      padding-bottom: 6px;
      border-bottom: 1px solid #ebedf0;
      .name {
        flex: 1;
        margin-right: 4px;
        display: flex;
        .name-state {
          font-size: 12px;
          color: #999;
          margin: 2px 10px 0 0;
        }
        .title {
          display: inline-block;
          // width: 100px;
           flex: 1;
        }
      }
      .icon-box {
        display: flex;
        align-items: center;
        color: #ff6b31;
        .add {
          margin-right: 10px;
        }
        .del {
          margin-right: 10px;
        }
      }
    }
    .add-goods-btn {
      margin 12px
      padding 6px 0
      text-align: center
      color $mainTextColor
      font-size 12px
      font-weight 600
      border 1px solid $mainTextColor
      border-radius 4px
    }
  }
  .add-range-btn {
    margin 15px
    padding 10px 0
    text-align: center
    color $mainTextColor
    font-size 14px
    font-weight 600
    border 1px solid $mainTextColor
    border-radius 8px
  }
}
</style>